import React from 'react';
import EventTaskDetailSubtasks from './eventDetailsTaskSubtasks';
import EventTaskDependencyPanel from './eventDetailsTaskDependencyPanel';
import EventTaskAttachmentPanel from './eventDetailsTaskAttachmentPanel';
import EventTaskCommentDock from './eventDetailsTaskCommentDock';
import DsModal from '../../common/DsModal';
import { ArticleSkeleton } from '../../common/ContentSkeletons';
import DsSelect from '../../common/DsSelect';

export default function EventTaskDetailModal({ view }) {
  const {
    PersonAvatar,
    TASK_PRIORITY_LABELS,
    TASK_PRIORITY_ORDER,
    TASK_STATUS_OPTIONS,
    closeEventTaskDetailModal,
    eventTaskAssignableAdmins,
    eventTaskCanEdit,
    eventTaskDependencies,
    eventTaskDependencyBlockRef,
    eventTaskDetailAssigneeAvatarUrl,
    eventTaskDetailAssigneeLabel,
    eventTaskDetailHasAssignee,
    eventTaskDetailDeleting,
    eventTaskDetailDueMeta,
    eventTaskDetailForm,
    eventTaskDetailModal,
    eventTaskDetailParentTask,
    eventTaskDetailSaving,
    eventTaskDetailSectionName,
    eventTaskDetailTask,
    eventTaskMetaEditField,
    eventTaskProject,
    eventTaskUpdatingId,
    formatAdminDisplay,
    formatDate,
    handleDeleteEventTaskDetail,
    handleSaveEventTaskDescription,
    handleToggleEventTaskStatus,
    isTaskDoneStatus,
    normalizeEventTaskStatus,
    normalizeTaskPriority,
    openEventTaskDetailModal,
    patchEventTaskInline,
    setEventTaskDetailForm,
    setEventTaskMetaEditField,
  } = view;

  return (
    <>
          <DsModal
            open={Boolean(eventTaskDetailModal)}
            onClose={closeEventTaskDetailModal}
            title="タスク詳細"
            size="lg"
            className="event-task-detail-modal"
          >
                {!eventTaskDetailTask ? (
                  <div className="event-task-detail-modal__loading">
                    <ArticleSkeleton lines={5} />
                  </div>
                ) : (
                  <div className="event-task-detail-modal__body">
                    <div className="event-task-detail-modal__toolbar">
                      <button
                        type="button"
                        className={`event-task-detail-modal__doneBtn ${
                          isTaskDoneStatus(eventTaskDetailTask.status) ? 'is-done' : ''
                        } is-priority-${normalizeTaskPriority(eventTaskDetailTask.priority)}`}
                        disabled={!eventTaskCanEdit || eventTaskUpdatingId === eventTaskDetailTask.id}
                        onClick={() => {
                          void handleToggleEventTaskStatus(eventTaskDetailTask);
                        }}
                        aria-label={
                          isTaskDoneStatus(eventTaskDetailTask.status)
                            ? '未着手に戻す'
                            : '完了にする'
                        }
                        title={
                          isTaskDoneStatus(eventTaskDetailTask.status)
                            ? '未着手に戻す'
                            : '完了にする'
                        }
                      >
                        <i className="fa-solid fa-check" />
                        <span>
                          {isTaskDoneStatus(eventTaskDetailTask.status)
                            ? '未着手に戻す'
                            : '完了にする'}
                        </span>
                      </button>
                      <div className="event-task-detail-modal__toolbarActions">
                        <button
                          type="button"
                          className="event-task-detail-modal__deleteBtn"
                          onClick={() => {
                            void handleDeleteEventTaskDetail();
                          }}
                          disabled={!eventTaskCanEdit || eventTaskDetailDeleting}
                          aria-label="タスクを削除"
                          title="タスクを削除"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </button>
                        <button
                          type="button"
                          className="event-task-detail-modal__toolbarClose"
                          onClick={closeEventTaskDetailModal}
                          aria-label="閉じる"
                          title="閉じる"
                        >
                          <i className="fa-solid fa-arrow-right-to-bracket" />
                        </button>
                      </div>
                    </div>

                    <div className="event-task-detail-modal__taskBody">
                        <div className="event-task-detail-modal__titleWrap">
                          <p className="event-task-detail-modal__title">
                            {eventTaskDetailTask.title || '名称未設定'}
                          </p>
                        </div>
                        <p className="event-task-detail-modal__sectionText">{eventTaskDetailSectionName}</p>
                        {eventTaskDetailParentTask ? (
                          <button
                            type="button"
                            className="event-task-detail-modal__parentTaskButton"
                            onClick={() => openEventTaskDetailModal(eventTaskDetailParentTask)}
                          >
                            親タスク: {eventTaskDetailParentTask.title || '名称未設定'}
                          </button>
                        ) : null}

                        <div className="event-task-detail-modal__metaRows">
                          <div className="event-task-detail-modal__metaRow">
                            <span>担当者</span>
                            <div className="event-task-detail-modal__metaValue">
                            {eventTaskMetaEditField === 'assignee' && eventTaskCanEdit ? (
                              <DsSelect
                                autoFocus
                                value={eventTaskDetailForm.assigneeId}
                                onBlur={() => setEventTaskMetaEditField('')}
                                onChange={(e) => {
                                  const nextAssigneeId = String(e.target.value || '');
                                  setEventTaskDetailForm((prev) => ({
                                    ...prev,
                                    assigneeId: nextAssigneeId,
                                  }));
                                  setEventTaskMetaEditField('');
                                  void patchEventTaskInline(
                                    eventTaskDetailTask.id,
                                    { assigneeIds: nextAssigneeId ? [Number(nextAssigneeId)] : [] },
                                    '担当者を更新しました。'
                                  );
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                <option value="">未割当</option>
                                {eventTaskAssignableAdmins.map((admin) => (
                                  <option key={admin.adminUserId} value={String(admin.adminUserId)}>
                                    {formatAdminDisplay(admin)}
                                  </option>
                                ))}
                              </DsSelect>
                            ) : (
                              <button
                                type="button"
                                className="event-task-detail-modal__metaTrigger"
                                onClick={() => {
                                  if (!eventTaskCanEdit) return;
                                  setEventTaskMetaEditField('assignee');
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                <span className="event-task-detail-modal__assigneeLabel">
                                  {eventTaskDetailHasAssignee ? (
                                    <PersonAvatar
                                      role="admin"
                                      name={eventTaskDetailAssigneeLabel}
                                      imageUrl={eventTaskDetailAssigneeAvatarUrl}
                                      className="event-task-panel__focusAssigneeAvatar"
                                      size={20}
                                      ariaHidden
                                    />
                                  ) : (
                                    <span
                                      className="event-task-panel__focusAssigneeAvatar event-task-panel__focusAssigneeAvatar--empty"
                                      aria-hidden="true"
                                    >
                                      <i className="fa-solid fa-user" />
                                    </span>
                                  )}
                                  <span>{eventTaskDetailAssigneeLabel}</span>
                                </span>
                              </button>
                            )}
                            </div>
                          </div>
                          <div className="event-task-detail-modal__metaRow">
                            <span>開始日</span>
                            <div className="event-task-detail-modal__metaValue">
                            {eventTaskMetaEditField === 'starts_on' && eventTaskCanEdit ? (
                              <div className="event-task-detail-modal__metaInline">
                                <input
                                  type="date"
                                  autoFocus
                                  value={eventTaskDetailForm.startsOn}
                                  onBlur={() => setEventTaskMetaEditField('')}
                                  onChange={(e) => {
                                    const nextStartsOn = e.target.value || '';
                                    setEventTaskDetailForm((prev) => ({
                                      ...prev,
                                      startsOn: nextStartsOn,
                                    }));
                                    setEventTaskMetaEditField('');
                                    void patchEventTaskInline(
                                      eventTaskDetailTask.id,
                                      { startsOn: nextStartsOn || null },
                                      '開始日を更新しました。'
                                    );
                                  }}
                                  disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                                />
                                {eventTaskDetailForm.startsOn ? (
                                  <button
                                    type="button"
                                    className="event-task-detail-modal__metaInlineButton"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                      setEventTaskDetailForm((prev) => ({ ...prev, startsOn: '' }));
                                      setEventTaskMetaEditField('');
                                      void patchEventTaskInline(
                                        eventTaskDetailTask.id,
                                        { startsOn: null },
                                        '開始日を更新しました。'
                                      );
                                    }}
                                    disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                                  >
                                    解除
                                  </button>
                                ) : null}
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="event-task-detail-modal__metaTrigger"
                                onClick={() => {
                                  if (!eventTaskCanEdit) return;
                                  setEventTaskMetaEditField('starts_on');
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                {eventTaskDetailForm.startsOn
                                  ? formatDate(eventTaskDetailForm.startsOn)
                                  : '開始日未設定'}
                              </button>
                            )}
                            </div>
                          </div>
                          <div className="event-task-detail-modal__metaRow">
                            <span>期限</span>
                            <div className="event-task-detail-modal__metaValue">
                            {eventTaskMetaEditField === 'due' && eventTaskCanEdit ? (
                              <div className="event-task-detail-modal__metaInline">
                                <input
                                  type="date"
                                  autoFocus
                                  value={eventTaskDetailForm.dueOn}
                                  onBlur={() => setEventTaskMetaEditField('')}
                                  onChange={(e) => {
                                    const nextDueOn = e.target.value || '';
                                    setEventTaskDetailForm((prev) => ({
                                      ...prev,
                                      dueOn: nextDueOn,
                                    }));
                                    setEventTaskMetaEditField('');
                                    void patchEventTaskInline(
                                      eventTaskDetailTask.id,
                                      { dueOn: nextDueOn || null },
                                      '期限を更新しました。'
                                    );
                                  }}
                                  disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                                />
                                {eventTaskDetailForm.dueOn ? (
                                  <button
                                    type="button"
                                    className="event-task-detail-modal__metaInlineButton"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                      setEventTaskDetailForm((prev) => ({ ...prev, dueOn: '' }));
                                      setEventTaskMetaEditField('');
                                      void patchEventTaskInline(
                                        eventTaskDetailTask.id,
                                        { dueOn: null },
                                        '期限を更新しました。'
                                      );
                                    }}
                                    disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                                  >
                                    解除
                                  </button>
                                ) : null}
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="event-task-detail-modal__metaTrigger"
                                onClick={() => {
                                  if (!eventTaskCanEdit) return;
                                  setEventTaskMetaEditField('due');
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                <span className={`event-task-detail-modal__dueBadge is-${eventTaskDetailDueMeta.tone}`}>
                                  <i className="fa-regular fa-calendar" />
                                  <span>{eventTaskDetailDueMeta.label}</span>
                                  {eventTaskDetailDueMeta.hint ? <small>{eventTaskDetailDueMeta.hint}</small> : null}
                                </span>
                              </button>
                            )}
                            </div>
                          </div>
                          <div className="event-task-detail-modal__metaRow">
                            <span>ステータス</span>
                            <div className="event-task-detail-modal__metaValue">
                            {eventTaskMetaEditField === 'status' && eventTaskCanEdit ? (
                              <DsSelect
                                autoFocus
                                value={eventTaskDetailForm.status}
                                onBlur={() => setEventTaskMetaEditField('')}
                                onChange={(e) => {
                                  const nextStatus = normalizeEventTaskStatus(e.target.value);
                                  setEventTaskDetailForm((prev) => ({
                                    ...prev,
                                    status: nextStatus,
                                  }));
                                  setEventTaskMetaEditField('');
                                  void patchEventTaskInline(
                                    eventTaskDetailTask.id,
                                    { status: nextStatus },
                                    'ステータスを更新しました。'
                                  );
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                {TASK_STATUS_OPTIONS.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.label}
                                  </option>
                                ))}
                              </DsSelect>
                            ) : (
                              <button
                                type="button"
                                className="event-task-detail-modal__metaTrigger"
                                onClick={() => {
                                  if (!eventTaskCanEdit) return;
                                  setEventTaskMetaEditField('status');
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                {normalizeEventTaskStatus(eventTaskDetailTask.status) === 'done' ? '完了' : '未着手'}
                              </button>
                            )}
                            </div>
                          </div>
                          <div className="event-task-detail-modal__metaRow">
                            <span>優先度</span>
                            <div className="event-task-detail-modal__metaValue">
                            {eventTaskMetaEditField === 'priority' && eventTaskCanEdit ? (
                              <DsSelect
                                autoFocus
                                value={eventTaskDetailForm.priority}
                                onBlur={() => setEventTaskMetaEditField('')}
                                onChange={(e) => {
                                  const nextPriority = normalizeTaskPriority(e.target.value);
                                  setEventTaskDetailForm((prev) => ({
                                    ...prev,
                                    priority: nextPriority,
                                  }));
                                  setEventTaskMetaEditField('');
                                  void patchEventTaskInline(
                                    eventTaskDetailTask.id,
                                    { priority: nextPriority },
                                    '優先度を更新しました。'
                                  );
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                {Object.keys(TASK_PRIORITY_ORDER).map((priorityKey) => (
                                  <option key={priorityKey} value={priorityKey}>
                                    {TASK_PRIORITY_LABELS[priorityKey]}
                                  </option>
                                ))}
                              </DsSelect>
                            ) : (
                              <button
                                type="button"
                                className="event-task-detail-modal__metaTrigger"
                                onClick={() => {
                                  if (!eventTaskCanEdit) return;
                                  setEventTaskMetaEditField('priority');
                                }}
                                disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                              >
                                {TASK_PRIORITY_LABELS[normalizeTaskPriority(eventTaskDetailTask.priority)]}
                              </button>
                            )}
                            </div>
                          </div>
                          <div className="event-task-detail-modal__metaRow">
                            <span>依存関係</span>
                            <div className="event-task-detail-modal__metaValue">
                              <button
                                type="button"
                                className="event-task-detail-modal__metaTrigger"
                                onClick={() =>
                                  eventTaskDependencyBlockRef.current?.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                  })
                                }
                              >
                                {eventTaskDependencies.predecessors.length +
                                  eventTaskDependencies.successors.length >
                                0
                                  ? `先行 ${eventTaskDependencies.predecessors.length} / 後続 ${eventTaskDependencies.successors.length}`
                                  : '依存関係を追加'}
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="event-task-detail-modal__projectInfoBlock">
                          <div className="event-task-detail-modal__projectInfoHead">
                            <span>
                              プロジェクト <em>1</em>
                            </span>
                            <button type="button" aria-label="プロジェクトを追加" disabled>
                              <i className="fa-solid fa-plus" />
                            </button>
                          </div>
                          <div className="event-task-detail-modal__projectInfoRow">
                            <span>{eventTaskProject?.name || '未設定プロジェクト'}</span>
                            <span>{eventTaskDetailSectionName}</span>
                          </div>
                          <div className="event-task-detail-modal__projectFieldRow">
                            <span>製造段階</span>
                            <span>{eventTaskDetailSectionName || '-'}</span>
                          </div>
                        </div>

                        <div className="event-task-detail-modal__descriptionBlock">
                          <h4>説明</h4>
                          <textarea
                            id="eventTaskDetailDescription"
                            value={eventTaskDetailForm.description}
                            onChange={(e) =>
                              setEventTaskDetailForm((prev) => ({
                                ...prev,
                                description: e.target.value,
                              }))
                            }
                            placeholder="タスク説明を入力"
                            disabled={!eventTaskCanEdit || eventTaskDetailSaving}
                          />
                          {eventTaskCanEdit ? (
                            <button
                              type="button"
                              className="event-task-detail-modal__descriptionSave"
                              onClick={() => {
                                void handleSaveEventTaskDescription();
                              }}
                              disabled={eventTaskDetailSaving}
                            >
                              {eventTaskDetailSaving ? '保存中...' : '説明を保存'}
                            </button>
                          ) : null}
                        </div>

                        <EventTaskDetailSubtasks view={view} />
                        <EventTaskDependencyPanel view={view} />
                        <EventTaskAttachmentPanel view={view} />
                        <EventTaskCommentDock view={view} />
                    </div>
                  </div>
                )}
          </DsModal>
    </>
  );
}
